module.exports = __webpack_public_path__ + "media/images/service/zl-d71fa4c3f47d596b97f7d59e072f0fe1.png";